// extracted by mini-css-extract-plugin
export default {"main":"UserListPage_main__mKJon","back":"UserListPage_back__flIkJ"};